/** Decimals offered for kilometre figures on the logbook pages. */
export const DISTANCE_DECIMAL_OPTIONS = [1, 3] as const;

export type DistanceDecimals = (typeof DISTANCE_DECIMAL_OPTIONS)[number];

export const DEFAULT_DISTANCE_DECIMALS: DistanceDecimals = 1;

/** A stored number back to an offered option; anything else falls back to the default. */
export function toDistanceDecimals(value: number): DistanceDecimals {
  return DISTANCE_DECIMAL_OPTIONS.find(option => option === value) ?? DEFAULT_DISTANCE_DECIMALS;
}
